export default __webpack_public_path__ + "0109c290e4e7d06758a894e4d9a8a22e.svg";